import { useLoaderData, useSearch } from "@tanstack/react-router";

import { buildUtmQueryParams } from "@/utils/utm";

const SURVEY_ROUTE_ID = "/_private/survey/";

export const useSurveyQueryParams = (): [string, string][] => {
  const surveyParams = useLoaderData({ from: SURVEY_ROUTE_ID });
  const { utm_content, utm_medium } = useSearch({ from: SURVEY_ROUTE_ID });

  return [
    ...surveyParams,
    ...(utm_content ? [["UtmContent", utm_content] as [string, string]] : []),
    ...buildUtmQueryParams(utm_medium),
  ];
};
